const camelcaseKeysDeep = require('camelcase-keys-deep');

export class Household {
  id: string;
  name: string;
  ownerId: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  createdDate: string;
  updatedDate: string;
  users: string[];
  phone1: string;
  phone1Type: string;
  phone2: string;
  phone2Type: string;

  constructor(data: any) {
    data = camelcaseKeysDeep(data);

    this.id = data.id;
    this.name = data.name;
    this.ownerId = data.ownerId;
    this.address1 = data.address1;
    this.address2 = data.address2;
    this.city = data.city;
    this.state = data.state;
    this.zip = data.zip;
    this.createdDate = data.createdDate;
    this.updatedDate = data.updatedDate;
    this.users = data.users;
    this.phone1 = data.phone1;
    this.phone1Type = data.phone1Type;
    this.phone2 = data.phone2;
    this.phone2Type = data.phone2Type;
  }
}



// WEBPACK FOOTER //
// ./src/app/households/household.ts